var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sign-in-container__controls" }, [
    _c(
      "div",
      { staticClass: "sign-in-container__checkbox-buttons" },
      [
        _c(
          "mds-checkbox",
          {
            staticClass: "checkbox-keep-logged",
            attrs: {
              name: "checkbox-keep-logged",
              value: "accept",
              "additional-class":
                "sign-in-container__controls-checkbox__keep-logged"
            },
            on: { change: _vm.handleKeepLogged }
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.$mwc.$t("rememberMeText")) + "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "mds-link link-forgot-password",
            attrs: {
              href: _vm.resetPasswordUrl,
              "aria-label": "Forgot your password ?",
              target: "_blank"
            }
          },
          [_vm._v(_vm._s(_vm.$mwc.$t("forgotPwdText")))]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "sign-in-container__controls-button" }, [
      _c(
        "button",
        {
          staticClass: "mds-button mds-button--primary",
          class: {
            "text-float-left": this.$mwc.labeller.languageId === "ar",
            "text-float-right": this.$mwc.labeller.languageId !== "ar"
          },
          attrs: {
            id: "loginButton",
            disabled: _vm.disableLoginBtn,
            type: "submit",
            text: "Login",
            tabindex: "0"
          }
        },
        [_vm._v("\n        " + _vm._s(_vm.$mwc.$t("loginText")) + "\n      ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }